import { ClinicalDocumentSearchParams } from 'app/integration/document/services/clinical-document';

export class AmbulanceCardSearchParams extends ClinicalDocumentSearchParams {
  public hospitalizationOrganizationCode: string;
  public signed: boolean;
}
